import { INext } from 'src/app/models/next.interface';



export interface INextState {
    next: INext;
}

export const initialNextState: INextState = {
    next: null
};
